module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', {
    attrs: {
      "body-padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "body",
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    }
  }, _vm._l((_vm.forms), function(item, index) {
    return _c('m-column', {
      key: index,
      style: ({
        'margin': index > 0 ? '10px 0' : ''
      }),
      attrs: {
        "title": item.title
      }
    }, [_c('div', {
      slot: "body"
    }, [_c('group', {
      attrs: {
        "gutter": "0"
      }
    }, [_vm._l((item.form), function(form, index) {
      return [(form.type === 'holderName') ? _c('x-input', {
        key: index,
        attrs: {
          "max": 8,
          "show-clear": false,
          "type": "text",
          "title": form.name,
          "placeholder": "请输入投保人姓名",
          "placeholder-align": "right",
          "text-align": "right"
        },
        on: {
          "on-blur": _vm.checkHolderName
        },
        model: {
          value: (_vm.holderName),
          callback: function($$v) {
            _vm.holderName = $$v
          },
          expression: "holderName"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'holderIDNumber') ? _c('x-input', {
        key: index,
        attrs: {
          "max": 18,
          "type": "text",
          "show-clear": false,
          "title": form.name,
          "placeholder": "请输入身份证号",
          "placeholder-align": "right",
          "text-align": "right"
        },
        on: {
          "on-blur": _vm.checkHolderIDNumber
        },
        model: {
          value: (_vm.holderIDNumber),
          callback: function($$v) {
            _vm.holderIDNumber = $$v
          },
          expression: "holderIDNumber"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'isHolderIDLongTerm') ? _c('x-switch', {
        key: index,
        attrs: {
          "id": "switch",
          "title": form.name + (_vm.isHolderIDLongTerm ? ('<span class=' + 'switch-content' + '>' + form.label + '</span>') : '')
        },
        on: {
          "on-change": _vm.changeHolderIDLongTerm
        },
        model: {
          value: (_vm.isHolderIDLongTerm),
          callback: function($$v) {
            _vm.isHolderIDLongTerm = $$v
          },
          expression: "isHolderIDLongTerm"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'holderIDBeginTerm' && !_vm.isHolderIDLongTerm) ? _c('datetime', {
        key: index,
        attrs: {
          "start-date": "1900-01-01",
          "end-date": _vm.formatDate.yesterday(),
          "default-selected-value": _vm.formatDate.yesterday(),
          "min-year": 1900,
          "max-year": 3017,
          "title": form.name,
          "placeholder": "请选择身份证有效起期",
          "confirm-text": "确定",
          "cancel-text": "取消"
        },
        on: {
          "on-change": _vm.changeHolderIDBeginTerm
        },
        model: {
          value: (_vm.holderIDBeginTerm),
          callback: function($$v) {
            _vm.holderIDBeginTerm = $$v
          },
          expression: "holderIDBeginTerm"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'holderIDEndTerm' && !_vm.isHolderIDLongTerm) ? _c('datetime', {
        key: index,
        attrs: {
          "start-date": _vm.formatDate.today(),
          "end-date": "3017-01-01",
          "min-year": 1900,
          "max-year": 3017,
          "title": form.name,
          "placeholder": "请选择身份证有效止期",
          "confirm-text": "确定",
          "cancel-text": "取消"
        },
        on: {
          "on-change": _vm.changeHolderIDEndTerm
        },
        model: {
          value: (_vm.holderIDEndTerm),
          callback: function($$v) {
            _vm.holderIDEndTerm = $$v
          },
          expression: "holderIDEndTerm"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'holderPhone') ? _c('x-input', {
        key: index,
        attrs: {
          "max": 11,
          "type": "tel",
          "show-clear": false,
          "title": form.name,
          "placeholder": "请输入手机号码",
          "placeholder-align": "right",
          "text-align": "right"
        },
        on: {
          "on-blur": _vm.checkHolderPhone
        },
        model: {
          value: (_vm.holderPhone),
          callback: function($$v) {
            _vm.holderPhone = $$v
          },
          expression: "holderPhone"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'holderPhoneCAPTCHA') ? _c('x-input', {
        key: index,
        attrs: {
          "max": 4,
          "type": "tel",
          "show-clear": false,
          "title": form.name,
          "placeholder": "请输入手机验证码",
          "placeholder-align": "right",
          "text-align": "right"
        },
        on: {
          "on-blur": _vm.checkHolderPhoneCAPTCHA
        },
        model: {
          value: (_vm.holderPhoneCAPTCHA),
          callback: function($$v) {
            _vm.holderPhoneCAPTCHA = $$v
          },
          expression: "holderPhoneCAPTCHA"
        }
      }, [_c('x-button', {
        staticStyle: {
          "margin-left": "4px"
        },
        attrs: {
          "disabled": _vm.CAPTCHACountdown === 0 ? false : true,
          "type": "primary",
          "mini": ""
        },
        nativeOn: {
          "click": function($event) {
            _vm.sendCAPTCHA($event)
          }
        },
        slot: "right"
      }, [_vm._v(_vm._s(_vm.CAPTCHALabel))])], 1) : _vm._e(), _vm._v(" "), (form.type === 'holderEmail') ? _c('x-input', {
        key: index,
        attrs: {
          "max": 50,
          "show-clear": false,
          "type": "text",
          "title": form.name,
          "placeholder": "请输入个人电子邮箱",
          "placeholder-align": "right",
          "text-align": "right"
        },
        on: {
          "on-blur": _vm.checkHolderEmail
        },
        model: {
          value: (_vm.holderEmail),
          callback: function($$v) {
            _vm.holderEmail = $$v
          },
          expression: "holderEmail"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'holderArea') ? _c('x-address', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!form.hide),
          expression: "!form.hide"
        }],
        key: index,
        attrs: {
          "title": form.name,
          "list": _vm.ChinaAddressData,
          "placeholder": form.placeholder || '请选择所在地区'
        },
        model: {
          value: (_vm.holderArea),
          callback: function($$v) {
            _vm.holderArea = $$v
          },
          expression: "holderArea"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'holderAddress') ? _c('x-input', {
        key: index,
        attrs: {
          "show-clear": false,
          "max": 50,
          "type": "text",
          "title": form.name,
          "placeholder": form.placeholder || '请输入详细地址',
          "placeholder-align": "right",
          "text-align": "right"
        },
        on: {
          "on-blur": _vm.checkHolderAddress
        },
        model: {
          value: (_vm.holderAddress),
          callback: function($$v) {
            _vm.holderAddress = $$v
          },
          expression: "holderAddress"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'insuredRelations') ? _c('cell', {
        key: index,
        attrs: {
          "title": form.name
        }
      }, [_c('m-candidate', {
        attrs: {
          "list": _vm.insuredRelations
        },
        on: {
          "change": _vm.changeRnsuredRelation
        },
        model: {
          value: (_vm.insuredRelation),
          callback: function($$v) {
            _vm.insuredRelation = $$v
          },
          expression: "insuredRelation"
        }
      })], 1) : _vm._e(), _vm._v(" "), (form.type === 'insuredName') ? _c('x-input', {
        key: index,
        attrs: {
          "disabled": _vm.insuredRelation === 1,
          "max": 8,
          "show-clear": false,
          "type": "text",
          "title": form.name,
          "placeholder": "请输入被保人姓名",
          "placeholder-align": "right",
          "text-align": "right"
        },
        on: {
          "on-blur": _vm.checkInsuredName
        },
        model: {
          value: (_vm.insuredName),
          callback: function($$v) {
            _vm.insuredName = $$v
          },
          expression: "insuredName"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'insuredIDNumber') ? _c('x-input', {
        key: index,
        attrs: {
          "disabled": _vm.insuredRelation === 1,
          "max": 18,
          "type": "text",
          "show-clear": false,
          "title": form.name,
          "placeholder": "请输入身份证号",
          "placeholder-align": "right",
          "text-align": "right"
        },
        on: {
          "on-blur": _vm.checkInsuredIDNumber
        },
        model: {
          value: (_vm.insuredIDNumber),
          callback: function($$v) {
            _vm.insuredIDNumber = $$v
          },
          expression: "insuredIDNumber"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'isInsuredIDLongTerm') ? _c('x-switch', {
        key: index,
        attrs: {
          "id": "switch",
          "disabled": _vm.insuredRelation === 1,
          "title": form.name + (_vm.isHolderIDLongTerm ? ('<span class=' + 'switch-content' + '>' + form.label + '</span>') : '')
        },
        model: {
          value: (_vm.isInsuredIDLongTerm),
          callback: function($$v) {
            _vm.isInsuredIDLongTerm = $$v
          },
          expression: "isInsuredIDLongTerm"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'insuredIDBeginTerm' && !_vm.isInsuredIDLongTerm) ? _c('datetime', {
        key: index,
        attrs: {
          "readonly": _vm.insuredRelation === 1,
          "start-date": "1900-01-01",
          "end-date": _vm.formatDate.yesterday(),
          "default-selected-value": _vm.formatDate.yesterday(),
          "min-year": 1900,
          "max-year": 3017,
          "title": form.name,
          "placeholder": "请选择身份证有效起期",
          "confirm-text": "确定",
          "cancel-text": "取消"
        },
        model: {
          value: (_vm.insuredIDBeginTerm),
          callback: function($$v) {
            _vm.insuredIDBeginTerm = $$v
          },
          expression: "insuredIDBeginTerm"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'insuredIDEndTerm' && !_vm.isInsuredIDLongTerm) ? _c('datetime', {
        key: index,
        attrs: {
          "readonly": _vm.insuredRelation === 1,
          "start-date": _vm.formatDate.today(),
          "end-date": "3017-01-01",
          "min-year": 1900,
          "max-year": 3017,
          "title": form.name,
          "placeholder": "请选择身份证有效止期",
          "confirm-text": "确定",
          "cancel-text": "取消"
        },
        model: {
          value: (_vm.insuredIDEndTerm),
          callback: function($$v) {
            _vm.insuredIDEndTerm = $$v
          },
          expression: "insuredIDEndTerm"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'insuredHeight') ? _c('x-input', {
        key: index,
        attrs: {
          "max": 3,
          "keyboard": "number",
          "show-clear": false,
          "title": form.name,
          "placeholder": "请输入身高(cm)",
          "placeholder-align": "right",
          "text-align": "right"
        },
        on: {
          "on-blur": _vm.checkInsuredHeight
        },
        model: {
          value: (_vm.insuredHeight),
          callback: function($$v) {
            _vm.insuredHeight = $$v
          },
          expression: "insuredHeight"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'insuredWeight') ? _c('x-input', {
        key: index,
        attrs: {
          "max": 3,
          "keyboard": "number",
          "show-clear": false,
          "title": form.name,
          "placeholder": "请输入体重(kg)",
          "placeholder-align": "right",
          "text-align": "right"
        },
        on: {
          "on-blur": _vm.checkInsuredWeight
        },
        model: {
          value: (_vm.insuredWeight),
          callback: function($$v) {
            _vm.insuredWeight = $$v
          },
          expression: "insuredWeight"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'occupation') ? _c('cell', {
        key: index,
        staticClass: "occupation holderOccupationName",
        attrs: {
          "title": form.name,
          "occupationtype": "1-6",
          "is-link": "",
          "primary": "content"
        }
      }, [_c('span', {
        ref: "occupation",
        refInFor: true,
        staticClass: "selected-occupation",
        staticStyle: {
          "margin-left": "3px"
        },
        attrs: {
          "code": form.default.code
        }
      }, [_vm._v(_vm._s(form.default.name))])]) : _vm._e(), _vm._v(" "), (form.type === 'holderOccupation') ? _c('cell', {
        key: index,
        staticClass: "occupation holderOccupationName",
        attrs: {
          "title": form.name,
          "occupationtype": "1-6",
          "is-link": "",
          "primary": "content"
        }
      }, [_c('span', {
        ref: "holderOccupation",
        refInFor: true,
        staticClass: "selected-occupation",
        staticStyle: {
          "margin-left": "3px"
        },
        attrs: {
          "code": _vm.holderOccupation.code
        }
      }, [_vm._v(_vm._s(_vm.holderOccupation.name))])]) : _vm._e(), _vm._v(" "), (form.type === 'insuredOccupation') ? _c('cell', {
        key: index,
        staticClass: "occupation holderOccupationName",
        attrs: {
          "title": form.name,
          "occupationtype": "1-6",
          "is-link": "",
          "primary": "content"
        }
      }, [_c('span', {
        ref: "insuredOccupation",
        refInFor: true,
        staticClass: "selected-occupation",
        staticStyle: {
          "margin-left": "3px"
        },
        attrs: {
          "code": _vm.insuredOccupation.code
        }
      }, [_vm._v(_vm._s(_vm.insuredOccupation.name))])]) : _vm._e(), _vm._v(" "), (form.type === 'coverages') ? _c('cell', {
        key: index,
        attrs: {
          "title": form.name
        }
      }, [_c('m-candidate', {
        attrs: {
          "list": _vm.coverages
        },
        on: {
          "change": _vm.getFee
        },
        model: {
          value: (_vm.coverage),
          callback: function($$v) {
            _vm.coverage = $$v
          },
          expression: "coverage"
        }
      })], 1) : _vm._e(), _vm._v(" "), (form.type === 'backMoney' && _vm.backMoney && _vm.feeSuccess) ? _c('cell', {
        key: index,
        attrs: {
          "title": form.name
        }
      }, [_vm._v(_vm._s(_vm.backMoneyStr))]) : _vm._e(), _vm._v(" "), (form.type === 'paymentPeriods') ? _c('cell', {
        key: index,
        attrs: {
          "title": form.name
        }
      }, [_c('m-candidate', {
        attrs: {
          "list": _vm.paymentPeriods
        },
        on: {
          "change": _vm.getFee
        },
        model: {
          value: (_vm.paymentPeriod),
          callback: function($$v) {
            _vm.paymentPeriod = $$v
          },
          expression: "paymentPeriod"
        }
      })], 1) : _vm._e(), _vm._v(" "), (form.type === 'insurancePeriods') ? _c('cell', {
        key: index,
        attrs: {
          "title": form.name
        }
      }, [_c('m-candidate', {
        attrs: {
          "list": _vm.insurancePeriods
        },
        on: {
          "change": _vm.getFee
        },
        model: {
          value: (_vm.insurancePeriod),
          callback: function($$v) {
            _vm.insurancePeriod = $$v
          },
          expression: "insurancePeriod"
        }
      })], 1) : _vm._e(), _vm._v(" "), (form.type === 'paymentWays') ? _c('cell', {
        key: index,
        attrs: {
          "title": form.name
        }
      }, [_c('m-candidate', {
        attrs: {
          "list": _vm.paymentWays
        },
        on: {
          "change": _vm.getFee
        },
        model: {
          value: (_vm.paymentWay),
          callback: function($$v) {
            _vm.paymentWay = $$v
          },
          expression: "paymentWay"
        }
      })], 1) : _vm._e(), _vm._v(" "), (form.type === 'paymentModes') ? _c('cell', {
        key: index,
        attrs: {
          "title": form.name
        }
      }, [_c('m-candidate', {
        attrs: {
          "list": _vm.paymentModes
        },
        on: {
          "change": _vm.changePaymentMode
        },
        model: {
          value: (_vm.paymentMode),
          callback: function($$v) {
            _vm.paymentMode = $$v
          },
          expression: "paymentMode"
        }
      })], 1) : _vm._e(), _vm._v(" "), (form.type === 'mild') ? _c('x-switch', {
        key: index,
        attrs: {
          "title": form.name
        },
        on: {
          "on-change": _vm.getFee
        },
        model: {
          value: (_vm.mild),
          callback: function($$v) {
            _vm.mild = $$v
          },
          expression: "mild"
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'mildCoverage' && _vm.mild) ? _c('cell', {
        key: index,
        attrs: {
          "title": form.name,
          "value": _vm.mildCoverage
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'cell') ? _c('cell', {
        key: index,
        attrs: {
          "title": form.name,
          "value": form.value
        }
      }) : _vm._e(), _vm._v(" "), (form.type === 'copies') ? _c('x-number', {
        key: index,
        attrs: {
          "fillable": true,
          "title": form.name + '（' + (_vm.paymentMode === 1 ? '1000' : '100') + '元/份）',
          "width": "40px",
          "min": _vm.copiesMin,
          "max": _vm.copiesMax,
          "step": form.constraints.step
        },
        model: {
          value: (_vm.coverage),
          callback: function($$v) {
            _vm.coverage = $$v
          },
          expression: "coverage"
        }
      }) : _vm._e()]
    })], 2)], 1)])
  })), _vm._v(" "), _c('tabbar', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('p', [_vm._v("价格："), _c('label', {
    staticClass: "mark"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "payment"
  }, [_vm._v(_vm._s(_vm.number))]), _vm._v("/" + _vm._s(_vm.paymentUnit)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feeSuccess === false),
      expression: "feeSuccess === false"
    }]
  }, [_vm._v(" 起")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn theme-bg-color",
    on: {
      "click": _vm.submitOrder
    }
  }, [_c('span', {
    staticClass: "btn-content"
  }, [_vm._v(_vm._s(_vm.content))])])])]), _vm._v(" "), _c('m-login', {
    attrs: {
      "showLogin": _vm.showLogin
    },
    on: {
      "close": _vm.closeLogin
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aba591e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form.vue
// module id = 689
// module chunks = 1